import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { HttpStatusCode } from 'axios';
import { useNavigate } from 'react-router-dom';
import { Message, MessageSharp } from '@mui/icons-material';
import { ScheduleList, ScheduleStatus } from '../../components/schedule/schedule';
import { useScheduleStore } from '../schedule/schedule_store';
import { ApiError, ApiResponse } from '../../../api/api';
import { WorkListReponse } from '../../../model/work_response';
import { useSessionStore } from '../../../context/session';
import styles from './index.module.scss';
import { DataTypeKeys } from '../../../constant';
import { Messages } from '../../../constant/messages';

/**
 * メイン画面のスケジュールエリア
 * @constructor
 */
export const MainScheduleView: React.FC = () => {
  const [status, setStatus] = useState<ScheduleStatus>(ScheduleStatus.none);
  const { getSchedules } = useScheduleStore((selector) => selector);
  const [data, setData] = useState<WorkListReponse>();
  const { selectedDivisionId } = useSessionStore((selector) => selector);
  const today = dayjs();
  const navigator = useNavigate();

  useEffect(() => {
    setStatus(ScheduleStatus.loading);
    getSchedules(today, 7, DataTypeKeys.dataTypeBispot, null, selectedDivisionId).then(
      (response: ApiResponse) => {
        if (!response.isError) {
          const res = response.data as WorkListReponse;
          setData(res);
          setStatus(ScheduleStatus.show);
        } else if (response.status === HttpStatusCode.NotFound) {
          setStatus(ScheduleStatus.error_no_data);
        } else {
          setStatus(ScheduleStatus.error_other);
        }
      },
    ).catch((e) => {
      if (e instanceof ApiError) {
        if (e.response.status === -1) {
          window.alert(Messages.ERR_DIALOG_TIMEOUT);
          setStatus(ScheduleStatus.error_timeout);
        }
      }
    });
  }, [selectedDivisionId]);

  const onClick = () => {
    navigator(`/schedule?division=${selectedDivisionId}&floor=0`);
  };

  return (
    <div className={styles.scheduleContainer}>
      <ScheduleList scheduleList={data} status={status} viewDate={today}/>
      { status === ScheduleStatus.show && <div className={styles.modeBtn} onClick={onClick}>もっとみる</div>}
    </div>
  );
};
